import index from '@/views/dealer/order/Index'
import list from '@/views/dealer/order/List'

export default {
  name: '订单管理',
  path: 'order',
  component: index,
  redirect: 'order/list',
  children: [{
    name: '订单列表',
    path: 'list',
    component: list,
    meta: {
    }
  }
  ]
}



// WEBPACK FOOTER //
// ./src/router/dealer/order/index.js